import i18n from "i18next";
import en from "./translations/en";
import fr from "./translations/fr";
import LanguageDetector from "i18next-browser-languagedetector";
import moment from "moment-timezone";
import { type TranslationsKeys } from "./translations/Translations";

require("moment/locale/en-gb");
require("moment/locale/fr");

export const LANGUAGE_FR = "fr";
export const LANGUAGE_EN = "en";
export const STORAGE_LANGUAGE_KEY = "ngStorage-ts_language";
const SUPPORTED_LANGUAGES = [LANGUAGE_FR, LANGUAGE_EN];

const storedLanguage = localStorage.getItem(STORAGE_LANGUAGE_KEY) ?? "";

export const LANGUAGE =
  (SUPPORTED_LANGUAGES.includes(storedLanguage) ? storedLanguage : undefined) ??
  navigator.language?.substring(0, 2) ??
  LANGUAGE_EN;
moment.locale(LANGUAGE);

i18n.use(LanguageDetector).init({
  lng: LANGUAGE,
  detection: {
    order: [
      "navigator",
      "cookie",
      "localStorage",
      "sessionStorage",
      "htmlTag",
      "querystring"
    ]
  },
  debug: false,
  resources: {
    fr: { translation: fr },
    en: { translation: en }
  },
  fallbackLng: LANGUAGE_EN,
  interpolation: {
    escapeValue: false
  }
});

export function changeLanguage(lng: string) {
  localStorage.setItem(STORAGE_LANGUAGE_KEY, lng);
  window.location.reload();
}

export function tt(key: keyof TranslationsKeys, vars?: any) {
  return i18n.t<string>(key, vars);
}

export default i18n;
